import { Pipe, PipeTransform } from '@angular/core';

import { DeviceLicense, DeviceLicenseWarningDetails } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceLicenseStateTextService } from '@shure/shared-angular-features-device-license-utils';

@Pipe({ name: 'licenseBannerMessage', pure: true, standalone: true })
export class LicenseBannerMessagePipe implements PipeTransform {
	constructor(private readonly deviceLicenseStateTextService: DeviceLicenseStateTextService) {}

	public transform(deviceLicense: DeviceLicense<DeviceLicenseWarningDetails> | undefined): string {
		let message = '';

		const title = this.deviceLicenseStateTextService.getTitle(deviceLicense?.state);
		const description = this.deviceLicenseStateTextService.getDescription(deviceLicense);

		if (title && description) {
			message = `${title}. ${description}`;
		}

		return message;
	}
}
